import { render, staticRenderFns } from "./ChangePlan.vue?vue&type=template&id=b39e064e&scoped=true"
import script from "./ChangePlan.vue?vue&type=script&lang=js"
export * from "./ChangePlan.vue?vue&type=script&lang=js"
import style0 from "./ChangePlan.vue?vue&type=style&index=0&id=b39e064e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b39e064e",
  null
  
)

export default component.exports